// extracted by mini-css-extract-plugin
module.exports = {"cardLoading":"CartLoading_cardLoading__3RZPQ","transparent":"CartLoading_transparent__VNNqa","spinner":"CartLoading_spinner__rBBFi","loading":"CartLoading_loading__GlNzb"};